import { PriceEnhancerRaw } from 'components/common-form/sidePanel/priceEnhancer/PriceEnhancerRaw';
import { useAppSelector } from 'hooks/useAppSelector';
import { useDispatch } from 'react-redux';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackPriceEnhanced } from 'state/missed-deal-feeedback/actions';
import { getUserFeedbackPriceEnhancement } from 'state/missed-deal-feeedback/selectors';

const MODE = 'UpfrontFee';
export function FeedbackPriceEnhancementController({ formId }: FormIdProps) {
  const { issuePrice, xMargin, tradingOffer } = useAppSelector(state => {
    const priceEnhancement = getUserFeedbackPriceEnhancement(state, formId)!;
    return {
      issuePrice: priceEnhancement.issuePrice * 100,
      xMargin: priceEnhancement.xMargin * 100,
      tradingOffer: priceEnhancement.tradingOffer * 100,
    };
  });
  const dispatch = useDispatch();
  return (
    <PriceEnhancerRaw
      issuePrice={issuePrice}
      xMargin={xMargin}
      tradingOffer={tradingOffer}
      mode={MODE}
      onFieldValueChanged={(field, value) => dispatch(missedDealFeedbackPriceEnhanced(formId, field, value))}
    />
  );
}
